import axios from 'axios'
import store from '../store';
const crypto = require('crypto')
const qs = require('qs')

const secret = 'CNF3ST0D4J'
const merchant_id = '1e35c2593a818da8bd8d376c5fccdbc717905f0d'
const postUrl = 'https://pay4.powercash21.com/powercash21-3-2/payment/init'
//const postUrl = process.env.VUE_APP_FRONT_URL + 'pay/payment/init'   //use localhost for dev testing - vue.config.js

export default class Powercash21Service {


    async initPayment(orderid, amount, userip) {

        var params = {
            merchantid: merchant_id,
            orderid: orderid, //change
            amount: amount,
            currency: 'EUR',
            email: store.state.currentUser.email,
            firstname: store.state.currentUser.first_name,
            lastname: store.state.currentUser.last_name,
            customerip: userip,
            custom1: store.state.currentUser.selected_package.id,
            payment_method: 1,
            // url_return: process.env.VUE_APP_FRONT_URL + '#/user/cc/payment_success'
            url_return: process.env.VUE_APP_AUTH_URL + 'process/payment'


        }

        var signature = this.getSignature(params)
        params.signature = signature
        console.log(params);
        
        const res = await axios({
            method: 'post',
            url: postUrl,
            data: qs.stringify(params)
        });

        return res.data;
    }

    getSignature(params) {
        var keys = Object.keys(params)
        keys.sort()
        var sum = ''
        keys.forEach(element => {
            sum += params[element]
        });
        sum += secret
        console.log('suma je: ' + sum)
        return crypto.createHash('sha1').update(sum).digest('hex')
    }


}